import { EmptyState } from '@repo/ui';
import { Navigate } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';
import { homeRouteFor } from '@/hooks/auth/home-route';
import { selectPermissions } from '@/store/auth.slice';
import { useAppSelector } from '@/store/store';

/** The address bar's `/`: sends a person to the first screen they may open. */
export function HomeRedirect() {
  const target = homeRouteFor(useAppSelector(selectPermissions));

  if (target === APP_ROUTES.home) return <EmptyState title="Nothing to show here yet" />;

  return <Navigate to={target} replace />;
}
